import { useSelector } from 'react-redux';
import { getRequestParams } from '../../../../../../../selectors/pageInfo';

/** Returns the request parameters (if any) used for the current req (SSR-safe) */
export default function useRequestParams(): Record<string, string> {
  return useSelector(getRequestParams) ?? {};
}
